import { get } from 'lodash';
import { UIElementType } from './ObjectAttribute';

export const extractValuesFromAttrs = (
  objectAttributeMetadata = {},
  objectAttributeValues = {}
) => {
  const initialValues = {};
  if (!objectAttributeMetadata) return initialValues;

  objectAttributeMetadata.map((attr) => {
    const values = get(objectAttributeValues, `${attr.code}.values`, []);
    if ([
      UIElementType.RADIO,
      UIElementType.CHECKBOXES,
      UIElementType.DROPDOWN
    ].includes(attr.ui_element)
    ) {
      const values = get(objectAttributeValues, `${attr.code}.form_values`) || [];
      initialValues[attr.code] = attr.is_multiple ? values : values[0];
    } else if (attr.ui_element === UIElementType.CHECKBOX) {
      initialValues[attr.code] = Boolean(get(values, '0', false));
    } else {
      initialValues[attr.code] = values.join(',') || '';
    }
  });
  return initialValues;
};
